import React from "react";
import { GoArrowUpRight } from "react-icons/go";
import { ReactSVG } from "react-svg";
import zeroTypingLogo from "../../Asset/ZEROTyingLogo.svg";
import { ShinyText } from "../Home/Home";
import { useInView } from "react-intersection-observer";

const bannerImage = process.env.PUBLIC_URL + "/images/download-banner.svg";

const DownloadBanner = ({ setIsOpen }) => {
  const { ref: iconRef, inView: iconView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: headingRef, inView: headingView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: buttonRef, inView: buttonView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  return (
    <>
      <div className="md:mx-[3%] mx-[2%] my-10">
        <div className=" w-full flex gap-8  bg-[#EBF7FE] rounded-3xl md:pt-6 md:pl-6 md:py-0 md:px-0 py-5 px-2 ">
          <div className=" md:w-[60%] w-full flex flex-col md:items-start items-center justify-center 2xl:gap-6 xl:gap-5 gap-4 md:pb-6">
            <div
              ref={iconRef}
              className={`${
                iconView ? `animate-scaleIn anim-preserve` : "opacity-0"
              }`}
            >
              <ReactSVG
                src={zeroTypingLogo}
                beforeInjection={(svg) => {
                  svg.setAttribute("class", "w-auto lg:h-12 md:h-9 h-8");
                }}
                className="w-auto"
              />
            </div>
            <div
              ref={headingRef}
              className={`${
                headingView
                  ? `animate-slideUp anim-preserve z-[3]`
                  : "opacity-0 z-0"
              } xl:text-[2.5rem] lg:text-[2.3rem] text-[2.1rem] text-center md:text-left font-jakarta font-semibold text-black`}
            >
              Coming Soon on <br className="flex md:hidden" />
              <ShinyText text=" iOS and Mac Os!" />
            </div>
            <div className=" xl:text-[1.438rem] z-4 relative bg-[#EBF7FE] lg:text-[1.2rem] md:text-[1.15rem] text-[1.313rem] text-center md:text-left font-inter font-medium text-[#00000099]">
              Coming soon to iOS and macOS. Experience seamless{" "}
              <br className=" lg:flex hidden" /> voice typing that’s accurate,
              fast, and made for <br className=" lg:flex hidden" />{" "}
              multitasking.
            </div>
            <button
              onClick={() => setIsOpen(true)}
              ref={buttonRef}
              className={` ${
                buttonView ? " animate-scaleIn anim-preserve" : "opacity-0"
              } w-max  md:text-base text-sm  group text-white font-semibold font-inter flex items-center gap-2 p-2 pl-5 rounded-full bg-[#3AB1F6]`}
            >
              Contact Us{" "}
              <span className=" bg-white text-[#3AB1F6] lg:p-2 p-1.5 rounded-full group-hover:rotate-45 transition-all duration-200">
                <GoArrowUpRight className="lg:size-5 sixe-4" />
              </span>
            </button>
          </div>
          <div className="md:w-[40%] md:flex hidden justify-center items-end relative  ">
            <ReactSVG
              src={bannerImage}
              className="2xl:w-[70%] xl:w-[75%] lg:w-[107%] h-auto absolute lg:-bottom-[10%] "
              beforeInjection={(svg) => {
                svg.classList.add("w-full", "h-auto");
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DownloadBanner;
